import { render, staticRenderFns } from "./RecipesDetailPage.vue?vue&type=template&id=2a281170&"
import script from "./RecipesDetailPage.vue?vue&type=script&lang=js&"
export * from "./RecipesDetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports